import { atom, useAtom, useSetAtom } from "jotai";

export type GeolocationError = {
  code: number;
  message: string;
};

export const waiterErrorDefault: GeolocationError | null = null;
export const waiterErrorAtom = atom(waiterErrorDefault);
const useWaiterError = () => {
  const atom = useAtom(waiterErrorAtom);
  return atom;
};

export const useSetWaiterError = () => useSetAtom(waiterErrorAtom);

export default useWaiterError;
